/**
 * Turns an auth API error into a message a non-technical user can act on.
 * Falls back through: network/status-level issues, then backend field
 * errors (in the given priority order), then a generic retry message.
 */
export const getAuthErrorMessage = (
  error: any,
  fieldOrder: string[] = [],
  fallback = "Something went wrong. Please try again, or contact us if this keeps happening."
): string => {
  if (!error) return ""

  if (!error.response) {
    return "We couldn't reach the server. Check your internet connection and try again."
  }

  const status = error.response.status
  const data = error.response.data

  if (status === 429) {
    return "Too many attempts. Please wait a few minutes and try again."
  }

  if (status >= 500) {
    return "Something went wrong on our end. Please try again in a moment."
  }

  if (data?.detail) return data.detail
  if (data?.non_field_errors?.[0]) return data.non_field_errors[0]

  for (const field of fieldOrder) {
    if (data?.[field]?.[0]) return data[field][0]
  }

  return fallback
}
